import { render, staticRenderFns } from "./AboutUsPage.vue?vue&type=template&id=425ed7de&scoped=true"
import script from "./AboutUsPage.vue?vue&type=script&lang=js"
export * from "./AboutUsPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/aboutUsPage.scss?vue&type=style&index=0&id=425ed7de&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ed7de",
  null
  
)

export default component.exports